import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PriceAlert, PriceAlertType } from 'src/app/models/price-alert';
import { PriceAlertService } from 'src/app/api/price-alert.service';
import { FiatExchangeRateService } from 'src/app/api/fiat-exchange-rate.service';
import { CurrenciesService } from 'src/app/api/currencies.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'price-alert-view',
  templateUrl: './price-alert-view.component.html',
  styleUrls: ['./price-alert-view.component.scss']
})
export class PriceAlertViewComponent implements OnInit {
  @Input() pair: string;
  @Input() priceAlert: PriceAlert;
  @Input() price: number = 0;
  @Input() useGlobalCurrency = false;
  @Output() save = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  PriceAlertType = PriceAlertType;
  mainCurrency: string;
  baseCurrency: string;

  globalCurrency = environment.currencies.globalCurrency;
  globalCurrencyRate = 0;

  loading = false;
  error: string = null;
  success = false;

  constructor(
    private priceAlertService: PriceAlertService,
    private fiatExchangeRateService: FiatExchangeRateService
  ) { }

  ngOnInit() {
    const currencies = this.pair ? this.pair.split('-') : ['', ''];
    this.mainCurrency = currencies?.[0];
    this.baseCurrency = currencies?.[1];

    if (this.useGlobalCurrency) {
      this.getGlobalCurrencyRate();
    } else {
      this.globalCurrencyRate = 1;
    }
  }

  getGlobalCurrencyRate() {
    this.fiatExchangeRateService.getGlobalCurrencyRate(this.baseCurrency).subscribe(response => {
      this.globalCurrencyRate = response;
    }, err => {
      this.globalCurrencyRate = 0;
    });
  }

  onSave() {
    this.loading = true;
    this.error = null;
    this.success = false;

    this.priceAlertService.save({
      amount: 0,
      pair: this.pair
    }, {
      amount: 0.00000001,
      pair: this.pair
    }, []).subscribe(response => {
      this.loading = false;
      this.success = true;
    }, err => {
      this.loading = false;
      this.error = err.errors[0].message;
    });
  }

  onCancel() {
    this.close.emit();
  }

  onFinish() {
    this.save.emit();
  }

  hasType(type: PriceAlertType) {
    return this.priceAlert.types.includes(type);
  }
}
